import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import Home from './components/Home';
import VendorApplication from './components/VendorApplication';
import ApplicationsAdmin from './components/ApplicationsAdmin.jsx';
import ProfilePage from './components/ProfilePage.jsx';
import VendorsAdmin from './components/VendorsAdmin.jsx';
import LayoutBuilder from './components/LayoutBuilder';
import BoothSelection from './components/BoothSelection.jsx';
import LayoutAdmin from './components/LayoutAdmin.jsx';
import AdminHolds from './components/AdminHolds.jsx';
import ManualReservation from './components/ManualReservation.jsx';
import ReservationsReport from './components/ReservationsReport.jsx';
import BoothsAdmin from './components/BoothsAdmin.jsx';
import BazaarCheckin from './components/BazaarCheckin.jsx';
import VendorCheckin from './components/VendorCheckin.jsx';
import ReservationLogsViewer from './components/ReservationLogsViewer.jsx';
import TransactionsAdmin from './components/TransactionsAdmin.jsx';
import TransactionDetail from './components/TransactionDetail.jsx';
import Attendees from './components/Attendees.jsx';
import PreCheckinSteps from './components/PreCheckinSteps.jsx';
import Events from './components/Events.jsx';
import ConfigDebug from './components/ConfigDebug';
import ManualPaymentPage from './components/ManualPaymentPage.jsx';
import StripeCheckout from './components/StripeCheckout.jsx';
import PaymentSuccess from './components/PaymentSuccess.jsx';
import EmailTemplatesAdmin from './components/EmailTemplatesAdmin.jsx';
import EmailTemplateLogsAdmin from './components/EmailTemplateLogsAdmin.jsx';
import './App.css';
import EnvBadge from './components/EnvBadge.jsx';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();
  return currentUser ? children : <Navigate to="/login" />;
};

// Public Route Component (redirects to home if already logged in)
const PublicRoute = ({ children }) => {
  const { currentUser } = useAuth();
  return !currentUser ? children : <Navigate to="/" />;
};

// Route requiring an approved application to access
import { useEffect, useState } from 'react';
// Removed hard redirect gating for browsing booths; checkout can remain gated elsewhere

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <EnvBadge />
        <Router>
          <Routes>
            <Route 
              path="/login" 
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              } 
            />
            <Route 
              path="/" 
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              } 
            />
              <Route 
                path="/apply" 
                element={<VendorApplication />} 
              />
            <Route 
              path="/layout-builder" 
              element={
                <ProtectedRoute>
                  <LayoutBuilder />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/booth-selection" 
              element={
                <ProtectedRoute>
                  <BoothSelection />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/profile/:uid" 
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/admin/vendors" 
              element={
                <ProtectedRoute>
                  <VendorsAdmin />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/admin/layouts" 
              element={
                <ProtectedRoute>
                  <LayoutAdmin />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/admin/holds" 
              element={
                <ProtectedRoute>
                  <AdminHolds />
                </ProtectedRoute>
              }
            />
            
            <Route 
              path="/admin/manual-reservation" 
              element={
                <ProtectedRoute>
                  <ManualReservation />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/admin/reservations-report" 
              element={
                <ProtectedRoute>
                  <ReservationsReport />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/admin/booths" 
              element={
                <ProtectedRoute>
                  <BoothsAdmin />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/admin/bazaar-checkin" 
              element={
                <ProtectedRoute>
                  <BazaarCheckin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/bazaar-checkin/:vendorId"
              element={
                <ProtectedRoute>
                  <VendorCheckin />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/admin/reservation-logs" 
              element={
                <ProtectedRoute>
                  <ReservationLogsViewer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/email-templates"
              element={
                <ProtectedRoute>
                  <EmailTemplatesAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/email-template-logs"
              element={
                <ProtectedRoute>
                  <EmailTemplateLogsAdmin />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/admin/applications" 
              element={
                <ProtectedRoute>
                  <ApplicationsAdmin />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/transactions" 
              element={
                <ProtectedRoute>
                  <TransactionsAdmin />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/transactions/:transactionId" 
              element={
                <ProtectedRoute>
                  <TransactionDetail />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/attendees" 
              element={
                <ProtectedRoute>
                  <Attendees />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/pre-checkin-steps" 
              element={
                <ProtectedRoute>
                  <PreCheckinSteps />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/events" 
              element={
                <ProtectedRoute>
                  <Events />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/test/stripe-payment" 
              element={
                <ProtectedRoute>
                  <ManualPaymentPage />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/checkout" 
              element={
                <ProtectedRoute>
                  <StripeCheckout />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/payment-success" 
              element={
                <ProtectedRoute>
                  <PaymentSuccess />
                </ProtectedRoute>
              }
            />
            {/* Catch all route - redirect to home */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Router>
        <ConfigDebug />
      </AuthProvider>
    </div>
  );
}

export default App;